//@flow

import React, { Fragment, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { parse } from 'query-string';
import { connect } from 'react-redux';
import { Button, Col, Container } from 'reactstrap';

import ImageUploader from '../../../components/ImageUploader';
import JumbotronImageSlider from '../../../components/JumbotronImageSlider';

import config from '../../../config';
import endpoints from '../../../lib/endpoints';
import type { Lodge } from '../helpers';
import { isSuperUser } from '../../../lib/utils';
import { addLodgeToTrekDay } from '../../../redux/actions/lodgeActions';
import { getCustomToast } from '../../../components/ErrorMessage';

type Props = {
  lodgeDetail: Lodge,
  searchQuery: string,
  fetchCoverImages: () => void,
  updateLodgeOnTrekDay: () => void,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateLodgeOnTrekDay: () => dispatch(addLodgeToTrekDay(ownProps.lodgeDetail.id)),
});

function Jumbotron(props: Props) {
  const [isLoading, setLoading] = useState(false);

  const onAdd = async () => {
    setLoading(true);
    try {
      await props.updateLodgeOnTrekDay();
      getCustomToast(
        'Lodge has been added to your trek. Please refresh the page to see changes',
        'success'
      );
    } catch (err) {
      getCustomToast(
        'Some error occurred during adding this lodge to your trek. Contact us or try again later',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  const {
    lodgeDetail: { name, region, id: lodgeId, albums, bannerImages },
    searchQuery,
  } = props;

  const { tid, isAdded } = parse(searchQuery);
  const isComeFromTrek = Boolean(tid);
  const isLodgeAdded = isAdded === 'true';

  const images = isEmpty(albums)
    ? [`${config.RESOURCE_URL}/${bannerImages.large}`]
    : albums.map(img => `${config.RESOURCE_URL}/${img.primaryImage}`).reverse();

  return (
    <Fragment>
      <div className="banner-image lodge-image" id="sd-lodge-image" data-lodge-image={images[0]}>
        <ImageUploader
          uploadUrl={`${endpoints.lodge.details(lodgeId)}/cover_image`}
          role={isSuperUser()}
          pageContext="lodgeDetail"
          multiple={true}
        >
          {imgUrl => (
            <JumbotronImageSlider
              showNav
              images={images}
              uploadedUrls={imgUrl}
              alt={`${name}, ${region}`}
            />
          )}
        </ImageUploader>
      </div>

      <div className="clearfix" />

      {isComeFromTrek && (
        <Col className="text-right overlap-buttons">
          <Container>
            <div className="btn-wrap clearfix">
              <Button
                className={`btn-secondary-action ${isLoading && 'btn-loading'}`}
                onClick={isLodgeAdded ? null : onAdd}
              >
                {isLodgeAdded ? 'Added To Trek' : 'Add To Trek'}{' '}
              </Button>
            </div>
          </Container>
        </Col>
      )}
    </Fragment>
  );
}

export default connect(
  null,
  mapDispatchToProps
)(Jumbotron);


// WEBPACK FOOTER //
// ./src/screens/Lodge/Details/Jumbotron.js